module.exports = __webpack_public_path__ + "img/top_bg.30666ba9.png";